import { pdfjs } from 'react-pdf';

// For Vite, we'll use the CDN version of the worker
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;
